import { h } from 'preact';
import { Link } from 'preact-router/match';
import style from './style.css';

const Header = () => (
	<header class={style.header}>
		<h1>NALLASIVAN GOVINDASAMY - PROFILE </h1>
		<nav class="intro-buttons">
			<Link activeClassName={style.active} href="mailto:nallasivan@gmail.com">Contact</Link>
			<Link class="primary" activeClassName={style.active} href="/NallasivanG.PDF">Download</Link>
		</nav>
</header>
);

export default Header;
